<template>
  <div id="DmhBookingCard">
    <div class="booking_inner brand-text" :class="isNewStyling ? 'booking-inner-row' : 'booking-inner-column'">
      <div class="booking-inner-top">
        <div class="px-1 d-flex flex-row align-items-start justify-content-start">
          <div>
            <span class="coach pb-1 brand-highlight-3">{{ getTitle(booking.appointmentType) }}</span>
            <br />
            <span class="day pb-1 brand-label">{{ booking.clinician.name }}</span>
            <br />
          </div>
        </div>
        <div class="underline"></div>
        <div class="d-flex justify-content-between">
          <p class="date brand-highlight-3 mr-2">{{ formatDate(booking.startTime) }}</p>
          <p class="hour brand-highlight-3">
            {{ getHoursMinutes(booking.startTime) }} -
            {{ getHoursMinutes(booking.endTime) }}
          </p>
        </div>
      </div>
      <div v-if="isUpcomingBooking" class="btn-wrapper" :class="isNewStyling ? 'btn-wrapper-contain' : 'btn-wrapper-full'">
        <b-button v-if="shouldShowLink || true" @click="handleClick(booking, serviceProvider)" variant="continue"
          class="video">
          <span v-if="booking.appointmentType !== 'face_to_face'">
            <span>Join</span>
          </span>
          <span v-else>Meeting Details</span>
        </b-button>
        <b-button v-if="isCancelButtonShown" @click="handleCancelClick(booking)" variant="cancel">
          Cancel
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import MeetingRoomModal from "./MeetingRoomModal.vue";
import EarlyModal from "./EarlyModal.vue";
import CancelModal from "./CancelModal.vue"
import F2FDetailsModal from "./F2FDetailsModal.vue";


export default {
  name: "DigitalClinicsBookingCard",
  props: {
    booking: Object,
    serviceProvider: Object,
    isEarliest: Boolean,
    isUpcomingBooking: Boolean,
    isNewStyling: Boolean
  },
  data() {
    return {
      shouldShowLink: true,
    };
  },
  computed: {
    isCancelButtonShown() {
      return !this.hasBookingStarted(this.booking.startTime)
    }
  },
  mounted() {
    let self = this;
    let now = moment();
    let bookingStart = moment(this.booking.startTime);
    if (this.isEarliest) {
      if (now.isSameOrAfter(bookingStart.subtract(10, "minute"))) {
        this.shouldShowLink = true;
      } else {
        let offset = bookingStart.diff(now);
        if (offset < 2147483647) {
          setTimeout(() => {
            self.shouldShowLink = true;
          }, offset);
        }
      }
    }
  },
  methods: {
    hasBookingStarted(startTime) {
      const now = new Date();
      const givenDate = new Date(startTime);
      const differenceInMilliseconds = givenDate - now;

      return (
        differenceInMilliseconds <= 0
      );
    },
    handleClick(booking, sp) {
      if (booking.appointmentType === 'face_to_face') {
        this.openDetailsModal(booking);
      } else if (booking.appointmentType.toLowerCase() === 'coaching') {
        this.$router.push("/booking-video-room/" + booking.appointmentId + "/device-tests");
      } else {
        this.openModal(booking, sp)
      }
    },
    handleCancelClick(booking) {
      if (booking.appointmentType === 'face_to_face') {
        this.$router.push('/message/' + booking.appointmentId + '/cancel' );
      } else {
        this.openCancelModal(booking)
      }
    },
    openModal(booking, sp) {
      if (moment(booking.start).diff(moment(), 'days') >= 1) {
        // this.openEarlyModal(booking, sp);
        this.openBookingModal(booking);
      } else {
        this.openBookingModal(booking);
      }
    },
    openCancelModal(booking) {
      const content = this.$createElement(CancelModal, { props: { booking } })
      const skin = this.$store.getters.skin;
      let opts = {
        title: "My Coaching Session",
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        headerClass: "coach_modal_header bg-brand-secondary d-flex justify-content-center",
        size: "md",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: 'cancel_modal'
      }
      return this.$bvModal.msgBoxOk(content, opts);
    },
    openBookingModal(booking, sp) {
      const content = this.$createElement(MeetingRoomModal, { props: { booking: booking } })
      const skin = this.$store.getters.skin;
      let opts = {
        title: "My Coaching Session",
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        headerClass: "coach_modal_header bg-brand-secondary d-flex justify-content-center",
        size: "lg",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: 'digital_clinics_modal'
      }
      return this.$bvModal.msgBoxOk(content, opts);
    },
    openDetailsModal(booking, sp) {
      const content = this.$createElement(F2FDetailsModal, { props: { booking: booking } })
      const skin = this.$store.getters.skin;
      let opts = {
        title: "My Upcoming Session",
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        headerClass: "coach_modal_header bg-brand-secondary d-flex justify-content-center",
        size: "lg",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: 'digital_clinics_modal'
      }
      return this.$bvModal.msgBoxOk(content, opts);
    },
    openEarlyModal(booking, sp) {
      const content = this.$createElement(EarlyModal, { props: { booking: booking } })
      const skin = this.$store.getters.skin;
      let opts = {
        title: "My Session",
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        headerClass: "coach_modal_header bg-brand-secondary d-flex justify-content-center",
        size: "md",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: 'digital_clinics_early_modal'
      }
      return this.$bvModal.msgBoxOk(content, opts);
    },
    getTitle(type) {
      if (this.booking.serviceName.includes('Neurodiversity')) {
        return `Neurodiversity \nVideo Call Consultation`
      } else if (type === 'Video') {
        return `${this.booking.serviceName} \nVideo Call Appointment`
      } else if (type === 'Audio') {
        return `${this.booking.serviceName} \nAudio Call Appointment`
      } else if (type === "face_to_face") {
        return 'Face to face Appointment'
      } else if (type.includes('Coaching')) {
        return `${this.booking.serviceName}`
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }).format(date);
    }
  },
};
</script>

<style lang="less">
#DmhBookingCard {
  .booking_inner {
    display: flex;
    border: 1px solid #E0E5F5;
    padding: 20px;
    margin-bottom: 15px;
    border-radius: 8px;

    &.booking-inner-row {
      flex-direction: row;
      gap: 20px;
    }

    &.booking-inner-column {
      flex-direction: column;
    }

    .booking-inner-top {
      width: 100%;
    }

    .underline {
      height: 1px;
      background-color: #E6E8F2;
      margin: 16px 0;
    }

    .img {
      max-width: 60px;
      max-height: 60px;
      border-radius: 8px;
      padding: 0 0 0 0 !important;
      margin-right: 10px;
    }

    .btn-wrapper {
      display: flex;
      flex-direction: row;
      gap: 12px;
      align-items: center;
      justify-content: space-between;
    }

    .btn {
      font-family: "PlusJakartaSansBold";
    }

    .btn-wrapper-full {
      margin-top: 16px;
    }

    .btn-wrapper-contain {
      max-width: 200px;
      width: 100%;

      .btn {
        min-width: 40%;
      }
    }

    .coach {
      white-space: pre-wrap;
      font-family: "PlusJakartaSansBold";
      font-size: 1.8rem;
    }

    .title {
      font-size: 1.6rem;
    }

    .day {
      font-family: "PlusJakartaSansRegular";
      font-size: 1.6rem;
    }

    .hour {
      font-size: 1.4rem;
    }

    .date {
      font-family: "PlusJakartaSansBold";
      font-size: 1.4rem;
    }

    p {
      margin-bottom: 0;
    }
  }

  .btn-continue {
    width: 100%;
    min-height: 48px;
    padding: 12px 10px;
    min-width: 70%;
    margin-bottom: 0;
  }

  .btn-cancel {
    width: 100%;
    padding: 12px 20px;
  }

  .btn.video {
    margin: 0;
  }

  @media screen and (max-width: 512px) {
    .booking_inner {

      &.booking-inner-row {
        flex-direction: column;
      }

      .btn-wrapper-contain {
        max-width: unset;

        .btn {
          min-width: unset;
          width: 100%;
          flex: 1 1 100%;
        }
      }
    }
  }

  @media screen and (max-width: 380px) {
    .btn-continue {
      min-width: 60%;
    }
  }
}
</style>
